/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ScrimmageRequestAcceptRejectEnum } from './ScrimmageRequestAcceptRejectEnum';
import {
    ScrimmageRequestAcceptRejectEnumFromJSON,
    ScrimmageRequestAcceptRejectEnumFromJSONTyped,
    ScrimmageRequestAcceptRejectEnumToJSON,
} from './ScrimmageRequestAcceptRejectEnum';

/**
 * 
 * @export
 * @interface TeamProfilePublic
 */
export interface TeamProfilePublic {
    /**
     * 
     * @type {string}
     * @memberof TeamProfilePublic
     */
    quote?: string;
    /**
     * 
     * @type {string}
     * @memberof TeamProfilePublic
     */
    biography?: string;
    /**
     * 
     * @type {boolean}
     * @memberof TeamProfilePublic
     */
    readonly has_avatar: boolean;
    /**
     * 
     * @type {string}
     * @memberof TeamProfilePublic
     */
    readonly avatar_url: string;
    /**
     * 
     * @type {number}
     * @memberof TeamProfilePublic
     */
    readonly rating: number;
    /**
     * 
     * @type {ScrimmageRequestAcceptRejectEnum}
     * @memberof TeamProfilePublic
     */
    auto_accept_reject_ranked?: ScrimmageRequestAcceptRejectEnum;
    /**
     * 
     * @type {ScrimmageRequestAcceptRejectEnum}
     * @memberof TeamProfilePublic
     */
    auto_accept_reject_unranked?: ScrimmageRequestAcceptRejectEnum;
    /**
     * 
     * @type {Array<number>}
     * @memberof TeamProfilePublic
     */
    eligible_for?: Array<number>;
}

/**
 * Check if a given object implements the TeamProfilePublic interface.
 */
export function instanceOfTeamProfilePublic(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "has_avatar" in value;
    isInstance = isInstance && "avatar_url" in value;
    isInstance = isInstance && "rating" in value;

    return isInstance;
}

export function TeamProfilePublicFromJSON(json: any): TeamProfilePublic {
    return TeamProfilePublicFromJSONTyped(json, false);
}

export function TeamProfilePublicFromJSONTyped(json: any, ignoreDiscriminator: boolean): TeamProfilePublic {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'quote': !exists(json, 'quote') ? undefined : json['quote'],
        'biography': !exists(json, 'biography') ? undefined : json['biography'],
        'has_avatar': json['has_avatar'],
        'avatar_url': json['avatar_url'],
        'rating': json['rating'],
        'auto_accept_reject_ranked': !exists(json, 'auto_accept_reject_ranked') ? undefined : ScrimmageRequestAcceptRejectEnumFromJSON(json['auto_accept_reject_ranked']),
        'auto_accept_reject_unranked': !exists(json, 'auto_accept_reject_unranked') ? undefined : ScrimmageRequestAcceptRejectEnumFromJSON(json['auto_accept_reject_unranked']),
        'eligible_for': !exists(json, 'eligible_for') ? undefined : json['eligible_for'],
    };
}

export function TeamProfilePublicToJSON(value?: TeamProfilePublic | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'quote': value.quote,
        'biography': value.biography,
        'auto_accept_reject_ranked': ScrimmageRequestAcceptRejectEnumToJSON(value.auto_accept_reject_ranked),
        'auto_accept_reject_unranked': ScrimmageRequestAcceptRejectEnumToJSON(value.auto_accept_reject_unranked),
        'eligible_for': value.eligible_for,
    };
}

